/********************************************************************
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/

export const recaptchaMessage = {
  failedFetch: 'Failed to fetch config from backend with status:',
  failedSetStorageConfig: 'Failed to set storage config',
  failedGetStorageConfig: 'Configuration could not be loaded.',
  failedExecutionRecaptcha: 'Recaptcha execution failed',
  failedInitializing: 'An error occurred while initializing ReCaptcha:',
};
